import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'

import { MesureResponseModel } from '@/domain/model/measures'

export const loadMeasuresByFormAndClientId = async (
  formId: string,
  clientId: string
): Promise<MesureResponseModel> => {
  const response = await makeGetRequest(
    ApiBase + `/forms/${formId}/measures/customers/${clientId}`,
    {}
  )

  return response
}
